import React from "react";
// eslint-disable-next-line import/no-unresolved
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import { Link } from "react-router-dom";
import trackAnalytics from "trackAnalytics";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import styles from "./SingleCard.module.css";

function SingleCard({
    tripStatus,
    tripPoints,
    driverName,
    driverNumber,
    truckType,
    truckPlateNumber,
    tripId,
    setSelectedTrip,
    selectedTrip,
    trip,
}) {
    return (
        <button
            className={` ${
                (selectedTrip?.id || selectedTrip?.tid) === trip?.id
                    ? styles.selectedCard
                    : styles.card
            }`}
            onClick={() => {
                setSelectedTrip((prev) => ((prev?.id || prev?.tid) === trip?.id ? null : trip));
                trackAnalytics("truck_focus_live_location", { selectedTripId: selectedTrip?.tid });
            }}
            type="button"
        >
            <div className={styles.header}>
                <div className={`${styles.status} ${styles[tripStatus]}`}>{tripStatus}</div>
                <div className={styles.tripInfo}>
                    <span
                        className={`${styles.callStatus} ${
                            trip?.connection ? styles[trip.connection] : styles.unknown
                        }`}
                    >
                        {trip.connection ? trip?.connection : "unknown"}{" "}
                        {trip?.minutesSinceLastConnection &&
                            `from ${trip?.minutesSinceLastConnection}`}
                    </span>
                    <Link
                        className={styles.orderId}
                        to={`/database/trips/${tripId}`}
                    >
                        {tripId}#
                    </Link>
                </div>
            </div>
            <div className={styles.locations}>
                {tripPoints.map((location, index) => (
                    <div
                        className={styles.locationItem}
                        key={index}
                    >
                        {location}
                        <span className={styles.locationIcon}>
                            <FmdGoodOutlinedIcon />
                        </span>
                    </div>
                ))}
            </div>
            <div className={styles.driverInfo}>
                <div className={styles.driverDetailsContainer}>
                    <div className={styles.driverDetails}>
                        <span className={styles.driverName}>{driverName}</span>
                        <span>{driverNumber}</span>
                    </div>
                    <AccountCircleOutlinedIcon />
                </div>

                <div className={styles.vehicleDetailsContainer}>
                    <div className={styles.vehicleDetails}>
                        <div>{truckType}</div>
                        <div>{truckPlateNumber}</div>
                    </div>

                    <span className={styles.vehicleIcon}>
                        <LocalShippingOutlinedIcon />
                    </span>
                </div>
            </div>
        </button>
    );
}

export default SingleCard;
